import { render, staticRenderFns } from "./LR.vue?vue&type=template&id=5a2fca33&scoped=true&"
import script from "./LR.vue?vue&type=script&lang=js&"
export * from "./LR.vue?vue&type=script&lang=js&"
import style0 from "./LR.vue?vue&type=style&index=0&id=5a2fca33&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2fca33",
  null
  
)

export default component.exports